import { TabRow } from '@/ui/tab-row';
import { PageHeader } from '@/ui/page-header';
import { EmptyState } from '@/ui/empty-state';

/**
 * The tab bar every Datasets screen renders under its own header.
 *
 * It used to live *inside* the catalog screen, which meant it existed only on the tab that drew it:
 * clicking Submissions or Remediation landed on a bare `Stub` with no way back but the sidebar. A
 * tab bar that disappears when you use it is worse than none.
 *
 * Shared as a component rather than a layout route because each tab owns its own subtitle — the
 * header has to come first, and a layout can only wrap.
 *
 * The mockups show a fourth "Detail" tab, and the Vendors mockup likewise shows "Detail Drawer" and
 * "Detail Page". Those are aids for reviewing the designs: a detail view needs a row to be about, so
 * it is reached by clicking one.
 */
const TABS = [
  { label: 'Submissions', to: '/admin/datasets' },
  { label: 'Catalog', to: '/admin/datasets/catalog' },
  { label: 'Remediation', to: '/admin/datasets/remediation' }
];

export function DatasetsTabs({ className }: { className?: string }) {
  return <TabRow tabs={TABS} className={className} />;
}

/** Not built. Rendered as a real tab rather than a bare stub so the tab bar stays reachable. */
export function DatasetsRemediation() {
  return (
    <div className="grid gap-5">
      <PageHeader title="Datasets" subtitle="Remediation" />
      <DatasetsTabs />
      <EmptyState title="Remediation has no design yet." note="Screen intentionally left empty" />
    </div>
  );
}
